import {
    type BillingDataAtomicPeriods,
    type BillingDataPeriods,
    type BillingDataResponse,
    type BillingDataStartFinishCreate,
    BILLING_DATA_ALL_PERIOD,
} from 'reactApp/api/billing/data/BillingDataAPICall.types';
import { billingDataFilterEnabled } from 'reactApp/appHelpers/featuresHelpers/features/billingDataEndpoint';

function normalize({ start: startTmstp = 0, finish: finishTmstp = 0, create: createTmstp = 0 }: BillingDataStartFinishCreate) {
    const create = createTmstp * 1000;
    let start;
    if (startTmstp && startTmstp > 0) {
        start = startTmstp * 1000;
    } else if (create) {
        start = create;
    }
    let finish;
    if (finishTmstp && finishTmstp > 0) {
        finish = finishTmstp * 1000;
    }
    return { start, finish };
}

export const filterPredicates: Record<BillingDataAtomicPeriods, (data: BillingDataStartFinishCreate) => boolean> = {
    past(data: BillingDataStartFinishCreate) {
        const requestTime = Date.now();
        const { finish } = normalize(data);
        if (!finish) {
            return false;
        }
        return finish <= requestTime;
    },
    current(data: BillingDataStartFinishCreate) {
        const requestTime = Date.now();
        const { start, finish } = normalize(data);
        if (!finish) {
            return start <= requestTime;
        }
        return start <= requestTime && requestTime < finish;
    },
    future(data: BillingDataStartFinishCreate) {
        const requestTime = Date.now();
        const { start: startTmstp = 0 } = data;
        const start = startTmstp * 1000;
        return start > requestTime;
    },
};

export const filterMethods = {
    getFilterValue(period: BillingDataAtomicPeriods): BillingDataPeriods {
        return billingDataFilterEnabled ? BILLING_DATA_ALL_PERIOD : period;
    },
    filterResponse(response: BillingDataResponse, filterFn: (args: BillingDataStartFinishCreate) => boolean): BillingDataResponse {
        const {
            android = [],
            bonus = [],
            gift_received = [],
            gift_sent = [],
            huawei = [],
            ios = [],
            promo = [],
            reward = [],
            rustore = [],
            web = [],
            referral = [],
        } = response.data;
        return {
            ...response,
            data: {
                web: web.filter(filterFn),
                android: android.filter(filterFn),
                ios: ios.filter(filterFn),
                bonus: bonus.filter(filterFn),
                gift_received: gift_received.filter(filterFn),
                gift_sent: gift_sent.filter(filterFn),
                huawei: huawei.filter(filterFn),
                promo: promo.filter(filterFn),
                reward: reward.filter(filterFn),
                rustore: rustore.filter(filterFn),
                referral: referral.filter(filterFn),
            },
        };
    },
};

export const filterBillingData = (
    requestFn: (period: BillingDataPeriods) => Promise<BillingDataResponse>,
    period: BillingDataAtomicPeriods
) =>
    requestFn(filterMethods.getFilterValue(period)).then((data) => {
        if (billingDataFilterEnabled) {
            return filterMethods.filterResponse(data, filterPredicates[period]);
        }
        return data;
    });
